import { Box } from '@deity/falcon-ui';
import { Select } from '@deity-io/portal-ui';
import type { FC } from 'react';

interface IMethodProps {
  isEditable: boolean;
  contentType?: string;
  parent?: string;
  onChange: (path: string[], val: string) => void;
}
export const ContentType: FC<IMethodProps> = ({ isEditable, contentType, parent, onChange }) => {
  const label = !contentType && parent ? `${parent.toUpperCase()} (inherited)` : 'Content Type';
  const isError = !contentType && !parent;

  return (
    <Box style={{ width: '50%' }}>
      <Select
        label={label}
        sx={{ marginY: 1 }}
        onChange={(val: any) => onChange(['contentType'], val?.value)}
        options={['application/json'].map(m => ({
          value: m,
          label: m.toUpperCase()
        }))}
        value={contentType ? { label: contentType?.toUpperCase(), value: contentType } : undefined}
        disabled={!isEditable}
        error={isError}
      />
    </Box>
  );
};
